import { IconButton } from "@mui/material";
import PlusIcon from "components/Icons/PlusIcon";
import MinusIcon from "components/Icons/MinusIcon";

/**
 * @param {object} props
 * @param {number} props.index Index in the choices array.
 * @param {string} props.value The value for the textbox.
 * @param {(value: string, index: number, type: string ) => void} props.onChangeLabel Called when a label changes.
 * @param {(value: string, index: number, type: string ) => void} props.onChangeValue Called when a value changes.
 * @param {() => void} props.onAdd Called when the add button is clicked.
 * @param {() => void} props.onRemove Called when the remove button is clicked.
 * @param {boolean} props.showRemoveButton `true` to show the remove button and `false` hide it.
 * @param {"checkbox" | "radio"} props.inputType Input type for the answer.
 * @param {boolean} isUpdateMode `true` if the question is being updated and `false` if it's being created.
 */
function ChoiceInput({
    choice,
    index,
    onChangeLabel,
    onChangeValue,
    onAdd,
    onRemove,
    showRemoveButton,
    inputType,
    isUpdateMode,
}) {
    return (
        <div style={{ display: "flex", gap: "16px" }}>
            {isUpdateMode && (
                <input
                    className="aq-question-settings"
                    style={{ width: "60px", height: "46px", padding: "11px 13px" }}
                    value={choice.value}
                    onChange={(e) => onChangeValue(e.target.value, index, inputType)}
                />
            )}

            <div style={{ display: "flex" }}>
                <input
                    className="aq-question-settings px-[13px] py-[11px] w-[320px]"
                    value={choice.label}
                    onChange={(event) => onChangeLabel(event.target.value, index, inputType)}
                    variant="outlined"
                    size="small"
                />
                <div className="flex items-center ml-3">
                    <IconButton className="p-1" onClick={() => onAdd(inputType)}>
                        <PlusIcon className="text-slate-300" />
                    </IconButton>

                    {showRemoveButton && (
                        <IconButton className="p-1" onClick={onRemove}>
                            <MinusIcon className="text-slate-300" />
                        </IconButton>
                    )}
                </div>
            </div>
        </div>
    );
}

export default ChoiceInput;
